import React, { useEffect, useState } from "react";
import {
  FlatList,
  View,
  Text,
  Image,
  TouchableOpacity,
  ActivityIndicator,
} from "react-native";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import color from "@constants/color";
import { getUpiMetadata } from "@services/api";
import { ScaledSheet } from '@utils/scale';
import Question from "@assets/svg/WithdrawGullakMoney/Question";
import t from "@constants/localization";

const FindUpi = ({ navigation, route }) => {
  const PATH = "screens/WithDrawGullakMoney/findUpi";
  const [selectedUpi, setSelectedUpi] = useState(null);
  const [upiMetaData, setUpiMetaData] = useState(null);
  const [isloading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const { data } = await getUpiMetadata();
        setUpiMetaData(data.upi_ids_meta);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  const renderItem = ({ item }) => {
    return (
      <TouchableOpacity
        testID="wgm-find-upi"
        onPress={() => {
          setSelectedUpi(item);
        }}
        style={[
          styles.upiItemContainer,
          {
            borderColor:
              selectedUpi?.type === item.type
                ? color.black
                : color.lighterBlack,
          },
        ]}
      >
        <Image source={{ uri: item.logo_url }} style={styles.upiItemImage} />
        <Text>{item.title}</Text>
      </TouchableOpacity>
    );
  };

  return (
    <View style={styles.container}>
      <HeaderWithBackAndTitle
        navigation={navigation}
        headertitle={t(`${PATH}/headerTitle`)}
        showBackButton={true}
        route={route}
      />
      {isloading ? (
        <View
          style={{
            height: "85%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ActivityIndicator
            size="large"
            color={color.primary}
            style={{ marginTop: 20 }}
          />
        </View>
      ) : (
        <View>
          <View style={styles.textContainer}>
            <Question />
            <Text style={styles.text}>{t(`${PATH}/howfindUPI`)}</Text>
          </View>
          <FlatList
            data={upiMetaData}
            horizontal
            showsHorizontalScrollIndicator={false}
            renderItem={renderItem}
            keyExtractor={(item, index) => index.toString()}
          />
          {selectedUpi && (
            <View style={styles.selectedUpiContainer}>
              <Text style={styles.selectedUpiTitle}>
                {selectedUpi?.img_title}
              </Text>
              <Image
                source={{ uri: selectedUpi?.image }}
                style={styles.selectedUpiImage}
              />
            </View>
          )}
        </View>
      )}
    </View>
  );
};

export default FindUpi;

const styles = ScaledSheet.create({
  container: {
    flexDirection: "column",
    justifyContent: "flex-start",
    paddingHorizontal: 6,
  },
  textContainer: {
    padding: 10,
    paddingTop: 20,
    flexDirection: "row",
    width: "100%",
    alignItems: "center",
  },
  text: {
    fontSize: 14,
    color: color.mediumBlack,
    fontWeight: "600",
    marginLeft: 4,
  },
  upiItemContainer: {
    flex: 1,
    backgroundColor: color.white,
    width: 95,
    height: 95,
    margin: 10,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,

    borderWidth: 1,
  },
  upiItemImage: {
    width: 40,
    height: 40,
    resizeMode: "contain",
  },
  selectedUpiContainer: {
    justifyContent: "center",
    alignItems: "center",
    margin: 10,
    borderRadius: 8,
    borderColor: color.lighterBlack,
    borderWidth: 1,
    padding: 10,
  },
  selectedUpiTitle: {
    fontSize: 16,
    fontWeight: "700",
  },
  selectedUpiImage: {
    marginTop: 10,
    width: "100%",
    aspectRatio: 0.8,
    resizeMode: "contain",
  },
});
